import {indexOf} from "core-js/internals/array-includes";

export const modelIntroCon = {
  'Biomarkers/02.Genus': 'Wilcoxon rank-sum test，也叫曼-惠特尼 U 检验（Mann–Whitney U test），是两组独立样本非参数检验的一种方法，当样本不符合正态分布时采用此算法。其原假设为两组独立样本来自的两总体分布无显著差异，通过对两组样本平均秩的研究来实现判断两总体的分布是否存在差异，该分析可以对两组样品的物种或代谢物进行显著性差异分析。差异分析后进一步使用 FDR 方法对得到的 p-value 进行校准，得到每一个研究物种或代谢物组间丰度比较的 Q- value，Q-value<0.05 表示该物种或代谢物在不同样本组中丰度存在显著差异。',
  'Correlation/01.Mantel_proc': 'Mantel test 是检验两个矩阵相关关系的非参数统计方法，由 Nathan Mantel 于 1967 年提出并发表。Mantel test 多用在生态学上，用来检验群落距离矩阵（比如，UniFrac distance matrix）和环境变量距离矩阵（比如，pH，温度或者地理位置的差异矩阵）之间的相关性。该方法的好处是不管什么样的数据，只要能计算有距离属性的值，都可以转化为距离矩阵进行分析，因此可以用于评估研究样品微生物群落与代谢组之间是否存在相关性。' +
    '\n\n       普氏分析（Procrutes analysis）用于评估两个排序分析的一致性，可以是两组不同的样品、同一组样品的两个相互独立的多元变量数据，也可以是同一数据所进行的两个不同排序分析之间的比较。',
  'Correlation/02.Distance-decay_similarity': '距离依赖的群落相似性是微生物生态学中重要的群落塑造模式，其主要表现为微生物群落组成结构的相似性随着研究样本间地理距离的增加或样本间环境异质性的增加而降低的过程。参考类似的方法，同样可以使用距离依赖相似性评估研究样本微生物群落组成结构与代谢物组成结构之间是否存在协同变化关系。\n' +
    '       对于一组研究样本，首先根据各样本的微生物 OTU 丰度丰度和代谢物丰度数据计算样本间的相似性距离（1-Bary-Cuttis 距离），随后使用线性回归的方法分析研究样本微生物群落相似性与代谢组相似性之间是否存在显著的线性相关性，分析过程使用 R 语言的“vegan”包和“ggplot2”包完成。',
  'Correlation/03.Heatmap': 'Heatmap 图可以用颜色变化来反映二维矩阵或表格中的数据信息，它可以直观地将数据值的大小以定义的颜色深浅表示出来。相关性 Heatmap 分析计算 Biomarker 分析中识别到的组间差异微生物物种和代谢物之间的相关性（pearson 系数）， 并将获得的数值矩阵直观的展示到 Heatmap 中，分析过程由 R 语言的“Hmisc”包和“pheatmap”包完成。',
  'Correlation/04.Networks': 'Cytoscape 是一款分子相互作用网络的可视化分析软件，通过对不同样本间的物种丰度信息进行相关性分析，可以获得物种在环境样本中的共存在关系，得到物种在同一环境下的相互作用的情况，进一步解释样本间表型差异的形成机制。也可以对代谢通路等功能的丰度信息进行相关性分析，分析功能间的相互关系，以及这些关系同环境之间的联系。Cytoscape 从可视化的角度去表现物种或代谢功能与样本、样本分类三者之间的相关关系，从网络结构图中发现重要的模式或信息。',
}
//表的介绍
const introCon = {
  'Biomarkers/*/wilcox/wilcox_all.xls': '所有*wilcox rank-sum test 的结果',
  'Biomarkers/*/wilcox/wilcox_biomarker.xls': '：Q-value 小于 0.05 的*wilcox rank-sum test结果',
  'Biomarkers/*/wilcox/Group_mean_abun_biomarker.xls': 'Biomarker组内平均丰度结果表',
  'Biomarkers/*/wilcox/Abun_change_biomarker.xls': 'Biomarker组间丰度变化结果表',
  'Biomarkers/*/RandomForest/importance.xls': '随机森林识别到的 Biomarker 及其统计结果表',
  'Biomarkers/*/RandomForest/biomarker_abundance.xls': '随机森林识别到的 Biomarker 在样本中的丰度统计表',
  'Biomarkers/*/Indicator/indicator.xls': 'IndVal 分析识别到的 indicators 及其统计结果表',
  'Biomarkers/*/Indicator/Group_mean_abun_indicator.xls': 'Indicators 组内平均丰度结果表',
  'Biomarkers/*/Indicator/Abun_change_indicator.xls': 'Indicators 组间丰度变化结果表',
  'Correlation/01.Mantel_proc/metabolite_bray_All': '所有研究样本代谢组的 Bray-Curtis 距离矩阵',
  'Correlation/01.Mantel_proc/metabolite_bray_Group': '每组样本微生物群落的 Bray-Curtis 距离矩阵',
  'Correlation/01.Mantel_proc/Mantel_proc_All': '所有样本 Mantel test 和普氏分析的统计学结果',
  'Correlation/01.Mantel_proc/Mantel_proc_Group': '每组样本分别进行 Mantel test 和普氏分析的统计学结果',
  'Correlation/02.Distance-decay_similarity/dcc_All': '所有研究样本距离依赖相似性绘图数据',
  'Correlation/02.Distance-decay_similarity/dcc_Group': '每组样本距离依赖相似性绘图数据',
  'Correlation/02.Distance-decay_similarity/regression_All': '所有研究样本距离依赖相似性线性回归结果',
  'Correlation/02.Distance-decay_similarity/regression_Group': '每组样本距离依赖相似性线性回归结果',
  'Correlation/03.Heatmap/*/correlation.xls': '相关系数结果表',
  'Correlation/03.Heatmap/*/pvalue.xls': '相关性分析 p-value 结果表',

}
const introConHtml = {}
const noteCon = {}
//图的介绍
const pictureCon = {
  'Biomarkers/*/wilcox/wilcox_biomarker_abun.pdf': 'wilcox rank-sum test 组间 biomarker 丰度变化组合图\n' +
    '根据差异检验结果，分别统计显著差异条目在每一个研究组中的丰度情况，计算差异条目组内平均丰度及组间丰度变化，使用 R 语言的 ggplot2 包绘制组间丰度变化组合图来展示差异物种的丰度变化情况\n' +
    '注：左侧条形图展示了识别到的 Biomarkers 在研究组中的平均丰度情况，右侧散点图展示了 Biomarkers 在组间的丰度变化情况，最右侧数值为物种组间 wilcox rank-sum test 得到的 Q-value。',
  'Biomarkers/*/RandomForest/RandomForest_biomarkder.pdf': '随机森林 Biomarker 识别结果及其在样本中的丰度分布图\n' +
    '注：左侧点阵图展示了识别到的 Biomarker 及其对分组的重要程度，保留 importance 高于 1.5 的结果，右侧的热图使用颜色梯度展示 Biomarker 在研究样本中的丰度，颜色越红代表丰度越高，灰色代表在样本中没有检出该 Biomarker。',
  'Biomarkers/*/RandomForest/classification.pdf': '随机森林模型对研究样本区分的准确性图\n' +
    '注：左上和右下的色块和数字代表随机森林模型对样本分组预测与实际情况一致的样品个数，右上和左下的色块和数字代表随机森林模型对样本分组预测与实际情况不一致的样品个数。',
  'Biomarkers/*/Indicator/Indicator_abun.pdf': '组间 Indicators 丰度变化组合图\n' +
    '注：左侧条形图展示了识别到的 Indicators 在研究组中的平均丰度情况，右侧散点图展示了 Indicators 在组间的丰度变化情况，最右侧数值为物种组间 Indicator 分析得到的 P-value。',
  'Correlation/01.Mantel_proc/Procrustes_*.pdf': '微生物群落和代谢组普氏分析结果图。\n' +
    '注：结果中红色的点代表微生物群落数据，蓝色的点代表代谢组数据，通过连线相连的两个点来自于同一个样本。',
  'Correlation/02.Distance-decay_similarity/ddcs_*.pdf': '微生物群落与代谢组距离依赖相似性图\n' +
    '注：横坐标为样本两两之间的代谢组相似性，纵坐标为样本两两之间的微生物群落相似性，拟合曲线为两者相性回归结果。',
  'Correlation/03.Heatmap/*.pdf': '关键物种与代谢物相关性 Heatmap图 \n' +
    '注：横纵坐标分别代表用于分析的关键物种和代谢物，热图色块的颜色代表 Pearson 相关性分析得到的相关系数，红色代表正相关，蓝色代表负相关，+代表关键物种和代谢物具有显著的相关性并且 p-value<0.05，++代表关键物种和代谢物具有极显著的相关性并且 p-value<0.01。',
  'Correlation/04.Networks/All/*.pdf': '全部物种和代谢物 Network图\n' +
    '注：OTU 和细菌属选择在所有样本中平均丰度高于 0.1%的条目，并且分析之前去除了在样本中检出率低于 60%的 OTU/ 细菌属和代谢物，以降低分析结果的假阳性，其余图形参数与关键 Biomarkers Network 结果图一致。',
  'Correlation/04.Networks/*': 'Cytoscape 网络关联分析图 \n' +
    '注：途中每个节点代表分析所用的关键物种或代谢物，蓝色节点代表关键物种橙色节点代表关键代谢物，节点之间的连线代表两者存在显著的相关关系（相关系数的绝对值在 0.8 以上，p-value<0.05），红色的连线代表正相关，蓝色的连线代表负相关。',

}

export function note(fileName) {
  fileName = pathFormat(fileName)
  return noteCon[fileName]
}

export function introduce(fileName, folder) {
  console.log(folder)
  if (folder) {
    folder = folder.substring(3)
    //01
    if (folder.includes("Biomarkers")) {
      let type = folder.includes("02.Genus") ? '细菌属' : folder.includes("03.Metabolites") ? '代谢物' : 'OTU'
      folder = folder.replace("01.OTU", '*').replace("02.Genus", '*').replace("03.Metabolites", '*')

      let returnValue = introCon[folder] ? ('说明：' + introCon[folder].replace("*", type)) : ''
      return returnValue
    }
    //02.01
    if (folder.includes('Correlation/01.Mantel_proc/')) {
      if(fileName.includes("_all")){
        if(fileName.includes('microbe_bray')){
          folder='Correlation/01.Mantel_proc/metabolite_bray_All'
        }else {
          folder='Correlation/01.Mantel_proc/Mantel_proc_All'
        }
      }else {
        if(fileName.includes('microbe_bray')){
          folder='Correlation/01.Mantel_proc/metabolite_bray_Group'
        }else {
          folder='Correlation/01.Mantel_proc/Mantel_proc_Group'
        }
      }
    }
    //02.02
    if (folder.includes('Correlation/02.Distance-decay_similarity/')) {
      if(fileName.includes("_all")){
        if(fileName.includes('ddcs')){
          folder='Correlation/02.Distance-decay_similarity/dcc_All'
        }else {
          folder='Correlation/02.Distance-decay_similarity/regression_All'
        }
      }else {
        if(fileName.includes('ddcs')){
          folder='Correlation/02.Distance-decay_similarity/dcc_Group'
        }else {
          folder='Correlation/02.Distance-decay_similarity/regression_Group'
        }
      }
    }
    //02.03
    if (folder.includes('Correlation/03.Heatmap')) {
      if (folder.includes('correlation.xls')) {
        folder = "Correlation/03.Heatmap/*/correlation.xls"
      } else if (folder.includes('pvalue.xls')) {
        folder = "Correlation/03.Heatmap/*/pvalue.xls"

      }
    }

    if (introCon[folder]) {
      return '说明：' + introCon[folder]
    } else {
    }
  }
}

export function getHtmlCon(fileName, folder) {
  folder = pathFormat(folder.substring(3))
  if (introConHtml[folder]) {
    return introConHtml[folder]
  } else {
    return '********'
  }
}

export function getModelIntro(path) {
  path = path.substring(3)
  return modelIntroCon[path]
}

export function tranChinese(name) {
  switch (name) {
    case'OTU':
      name = 'OTU';
      break;
    case 'Genus':
      name = '细菌属';
      break;
    case 'Metabolites':
      name = '代谢物';
      break;
  }
  return name
}

export function pathFormat(path) {
  //05
  path = path.replace("Bray_Curtis", "*").replace("Weighted_Unifrac", "*").replace("Unweighted_Unifrac", "*")
  //10
  path = path.replace(new RegExp("^Network/Group(/.*?)/"), "Network/Group/")
  path = path.replace("Phylum", "*").replace("Class", "*").replace("Order", "*").replace("Family", "*").replace("Genus", "*").replace("Species", "*")
  //network
  return path
}

export function getPictureCon(fileName, folder) {

  if (folder) {
    folder = folder.substring(3)
    if (folder.includes('Biomarkers')) {
      folder = folder.replace("01.OTU", '*').replace("02.Genus", '*').replace("03.Metabolites", '*')
    }
    if (folder.includes("Correlation/01.Mantel_proc/Procrustes")) {
      folder = "Correlation/01.Mantel_proc/Procrustes_*.pdf"
    }
    if (folder.includes("Correlation/02.Distance-decay_similarity/ddcs")) {
      folder = "Correlation/02.Distance-decay_similarity/ddcs_*.pdf"
    }
    if (folder.includes("Correlation/03.Heatmap/")) {
      folder = "Correlation/03.Heatmap/*.pdf"
    }
    if (folder.includes("Correlation/04.Networks")) {
      if (folder.includes('All')) {
        folder = "Correlation/04.Networks/All/*.pdf"
      } else {
        folder = "Correlation/04.Networks/*/"
      }

    }
    return pictureCon[folder] ? pictureCon[folder] : '**********'
  }

}
